/**
 * Building Templates and getting information about them.
 *
 * @since 0.4.0
 */
import { Template } from '~/src/design/template';
import { Requestor } from '~/src/api/Requestor';
import { Quote } from '~/src/pricing/quote';

/**
 * Get the price of the design.
 *
 * @since 0.4.0
 */
export const priceDesign =
	(req: Requestor) =>
		(
			Design: Template,
			Tier: string,
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			Install: any,
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			Rules: any,
		): Promise<Quote> =>
			req.request(Quote)('price/design', 'POST', {
				Design,
				Tier,
				Install,
				Labor: {},
				Rules
			});
